import { Instagram, Linkedin, Mail } from 'lucide-react';

const socialLinks = [
    {
        href: 'mailto:deepaliagrawal224@gmail.com',
        icon: Mail,
        label: 'Email',
    },
    {
        href: 'https://www.linkedin.com/in/deepali-agrawal-1910/',
        icon: Linkedin,
        label: 'LinkedIn',
    },
    {
        href: 'https://www.instagram.com/_orange.palette_/',
        icon: Instagram,
        label: 'Instagram',
    },
];

export default function Footer() {
    return (
        <footer className="py-12 border-t border-warm-gray-200 mt-auto">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                {/* Copyright */}
                <p className="text-sm text-warm-gray-500 order-2 md:order-1">
                    © {new Date().getFullYear()} Deepali Agrawal. All rights reserved.
                </p>

                {/* Social Links */}
                <div className="flex items-center gap-6 order-1 md:order-2">
                    {socialLinks.map((link) => (
                        <a
                            key={link.label}
                            href={link.href}
                            target={link.href.startsWith('mailto') ? undefined : '_blank'}
                            rel={link.href.startsWith('mailto') ? undefined : 'noopener noreferrer'}
                            className="text-warm-gray-500 hover:text-warm-gray-800 transition-colors"
                            aria-label={link.label}
                        >
                            <link.icon size={20} />
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
}
